exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-small {\n  width: 30px;\n  height: 30px; }\n\n.icon-medium {\n  width: 40px;\n  height: 40px; }\n\n.icon-big {\n  width: 75px;\n  height: 75px;\n  font-size: 2rem; }\n\n.circle {\n  border-radius: 50%; }\n\n.border-white {\n  border: 1px solid #fff;\n  background-color: rgba(255, 255, 255, 0.5); }\n\n.only-border-white {\n  border: 1px solid #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/user-avatar/user-avatar.scss
// module id = ../../../../../src/app/components/common/user-avatar/user-avatar.scss
// module chunks = 0